<div class="content">
    <app-header></app-header>
    <div *ngIf="(errorStore$ | async) === true" class="row"style="max-width: 100%;">
        <div class="col-md-10 offset-md-1 col-12 offset-0 mb-3" style="padding-top: 4rem;">
            <div class="alert alert-danger my-2 py-3 text-center" role="alert">
                <i class="bi bi-exclamation-triangle"></i> Une erreur système ne permet pas d'utiliser correctement le site.
            </div>
        </div>
    </div>
    <div class="portailrh-container-global">

        <div  class="breadcrumb-container col-12">
            <app-breadcrumb [paths]="breadcrumbDatas$ | async"></app-breadcrumb>
        </div>

        <div class="container-fluid container-fluid-layout">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-footer [versionBack]="versionBack$|async"></app-footer>
</div>
